import textServices from 'services/text-services'
import { UPCOMING_EXPERIENCES } from '../constants'

const UpcomingExperiences = () => {
  return (
    <section className="afterwork__upcoming">
      <h2 className="afterwork__upcoming-title">
        {textServices.findByText('afterwork/upcoming/title', 'PRÓXIMAS EXPERIENCIAS')}
      </h2>
      <ul className="afterwork__upcoming-list">
        {UPCOMING_EXPERIENCES.map(({ city, month }, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <li key={`${city}-${index}`} className="afterwork__upcoming-row">
            <span className="afterwork__upcoming-city">{city}</span>
            <span className="afterwork__upcoming-month">{month}</span>
          </li>
        ))}
      </ul>
    </section>
  )
}

export default UpcomingExperiences
